<template>
  <el-form :model="data" :rules="ruleList" ref="form"
           :disabled="$has(permission)" @submit.native.prevent>
    <el-form-item v-for="(item, index) in fileList"  v-if="item.show !== false" v-bind:key="index"
                  :label="item.label" :label-width="item.labelWidth ? item.labelWidth : labelWidth" :prop="item.prop">
      <!-- input/textarea/number -->
      <el-input v-if="item.type === 'input' || item.type === 'textarea' || item.type === 'number'"
                v-model="data[item.prop]"
                :type="item.type"
                :placeholder="item.placeholder || '请输入'"
                :disabled="item.disabled"><template v-if="item.append" slot="append">{{item.append}}</template></el-input>
      <!-- password -->
      <el-input v-if=" item.type === 'password'"
                v-model="data[item.prop]"
                :type="item.type"
                :placeholder="item.placeholder || '请输入'"
                :disabled="item.disabled"
                :show-password="isShowPwd"
                @change="changePwd"></el-input>
      <!-- switch -->
      <el-switch v-if="item.type === 'switch'"
                 v-model="data[item.prop]" :active-value="1" :inactive-value="0"></el-switch>
      <!-- text -->
      <span v-if="item.type === 'text'">
          <span>{{data[item.prop]}}</span>
        </span>
      <!-- select -->
      <el-select v-if="item.type === 'select'" :multiple="item.multiple" placeholder="请选择" v-model="data[item.prop]" :disabled="item.disabled">
        <el-option v-for="(option, index) in item.options" v-bind:key="index"
                   :value="option.value || option.id" :label="option.label || option.name"></el-option>
      </el-select>
      <!-- datePicker -->
      <el-date-picker
        v-if="item.type === 'datePicker'"
        v-model="data[item.prop]"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期">
      </el-date-picker>
      <!--datePickerRange-->
      <el-date-picker
        v-if="item.type === 'datePickerRange'"
        v-model="data[item.prop]"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <!--dateTimePickerRange-->
      <el-date-picker
        v-if="item.type === 'dateTimePickerRange'"
        v-model="data[item.prop]"
        type="datetimerange"
        range-separator="至"
        value-format="yyyy-MM-dd HH:mm:ss"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <!-- cascader -->
      <el-cascader
        v-if="item.type === 'cascader'"
        v-model="data[item.prop]"
        :options="item.options"
        :props="item.props"
        @change="handleChange">
      </el-cascader>
      <!-- uploadPicture -->
      <el-row v-if="item.type === 'uploadPicture'" type="flex" justify="start" align="middle" :gutter="12">
        <el-col>
          <el-upload
            class="avatar-uploader"
            :action="$global.httpBaseURL + $global.uploadPath"
            :data="uploadData"
            :show-file-list="false"
            :on-success="(res, file) => handleAvatarSuccess(res, file, item.prop, item)"
            :before-upload="beforeAvatarUpload">
            <img v-if="data[item.prop] && data[item.prop].attachUrl" :src="data[item.prop].attachUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
        <el-col>
          <span class="upload-picture_tip">图片尺寸{{item.width}} X {{item.height}},不能大于1M</span>
        </el-col>
      </el-row>
      <!-- slot -->
      <template v-if="item.type === 'slot'">
        <slot :name="'form-' + item.prop" />
      </template>
    </el-form-item>
  </el-form>
</template>

<script>
import { checkPwd } from '../../utils/validate'
export default {
  name: 'pageForm',
  data () {
    return {
      isShowPwd: false,
      uploadData: {
        TOKEN_KEY: localStorage.getItem('token')
      }
    }
  },
  props: ['data', 'permission', 'ruleList',
    'fileList', 'labelWidth', 'submit'], // 接收父组件的方法
  computed: {
  },
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        if (this.$refs) {
          setTimeout(() => {
            this.$emit('update:refObj', this.$refs.form)
            this.isShowPwd = false
          }, 50)
        }
      },
      deep: true // 深度监听
    }
  },
  mounted () {
    // 将form实例返回到父级
    if (this.$refs.form) {
      this.$emit('update:refObj', this.$refs.form)
      this.isShowPwd = false
    }
  },
  methods: {
    handleChange (val) {
      // console.log(val, 'handleChange')
    },
    // 密码
    changePwd () {
      this.isShowPwd = true
      this.ruleList.pwd.validator = checkPwd
    },
    /*
    * 图片上传
    * */
    handleAvatarSuccess (res, file, prop, item) {
      if (res.code === 200) {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        })
        this.data[prop] = {
          ...this.data[prop],
          id: '',
          attachUrl: ''
        }
        this.data[prop].id = res.obj
        this.data[prop].attachUrl = URL.createObjectURL(file.raw)
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG或PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1M')
      }
      return isJPG && isLt2M
    }
  }
}
</script>

<style scoped>
  .avatar-uploader {
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .upload-picture_tip {
    color: #666666;
  }

  >>> .el-form-item__label {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Form/Index.vue